import MachineqLayout from "./layout.jsx"
// eslint-disable-next-line
import ConfigsPlugin from "corePlugins/configs"

// the MachineqLayout preset

import MqBaseLayout from "./components/MqBaseLayout.jsx"
import MqOperations from "./components/MqOperations.jsx"
import MqOperationTag from "./components/MqOperationTag.jsx"
import MqOperation from "./components/MqOperation.jsx"
import MqSidebar from "./components/MqSidebar.jsx"
import MqParamBody from "./components/MqParamBody.jsx"
import MqParameters from "./components/MqParameters.jsx"
import MqParameterRow from "./components/MqParameterRow.jsx"
import MqModelExample from "./components/MqModelExample.jsx"
import MqResponses from "./components/MqResponses.jsx"
import MqResponse from "./components/MqResponse.jsx"
import MqDeepLink from "./components/MqDeepLink.jsx"
import MqLiveResponse from "./components/MqLiveResponse.jsx"
import MqTopbar from "./components/MqTopbar.jsx"
import MqSubParameters from "./components/MqSubParameters.jsx"

const blacklistedQueryParams = ['url', 'go', 'configUrl'];
const searchParams = new URLSearchParams(window.location.search);
const paramsObj = Object.fromEntries(searchParams.entries()) || {};
const searchParamsList = Object.keys(paramsObj);
if (searchParamsList.length) {
  const blacklistedQueryParamsFound = searchParamsList.some(i => blacklistedQueryParams.includes(i));
  if (blacklistedQueryParamsFound) window.location = window.location.origin;
}

let preset = [
  ConfigsPlugin,
  {
    fn: {
      readyToScroll: (elId) => {
        const scrollToElId = window.location.hash.slice(1)

        if (elId === scrollToElId) {
          const elTop = document.getElementById(scrollToElId).getBoundingClientRect().top

          window.scrollTo(0, elTop)
        }
      }
    }
  },
  () => {
    return {
      components: {
        MachineqLayout,
        MqBaseLayout,
        operations: MqOperations,
        OperationTag: MqOperationTag,
        operation: MqOperation,
        mqsidebar: MqSidebar,
        ParamBody: MqParamBody,
        parameters: MqParameters,
        parameterRow: MqParameterRow,
        modelExample: MqModelExample,
        responses: MqResponses,
        response: MqResponse,
        DeepLink: MqDeepLink,
        liveResponse: MqLiveResponse,
        Topbar: MqTopbar,
        mqsubparameters: MqSubParameters
      }
    }
  }
]

module.exports = preset



// WEBPACK FOOTER //
// ./src/machineq/index.js